import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "inspect-multiple",
  "use": "inspect-multiple-usage",
  "viewBox": "0 0 44.55 52.39",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44.55 52.39\" id=\"inspect-multiple\"><title>资源 26</title><g data-name=\"图层 2\"><path d=\"M41.24 0H10.31A3.31 3.31 0 0 0 7 3.31V6H3.31A3.31 3.31 0 0 0 0 9.31v39.76a3.31 3.31 0 0 0 3.31 3.31h30.93a3.31 3.31 0 0 0 3.31-3.31v-2.68h3.69a3.31 3.31 0 0 0 3.31-3.31V3.31A3.31 3.31 0 0 0 41.24 0zM6.85 15.66a1.66 1.66 0 0 1 1.43-.83h8.84a1.66 1.66 0 0 1 0 3.31H8.28a1.66 1.66 0 0 1-1.43-2.48zm0 6.63a1.66 1.66 0 0 1 1.43-.83h8.84a1.66 1.66 0 1 1 0 3.31H8.28a1.66 1.66 0 0 1-1.43-2.48zM30.7 42.72a1.66 1.66 0 0 1-1.43.83h-21a1.66 1.66 0 1 1 0-3.31h21a1.66 1.66 0 0 1 1.43 2.49zm0-6.63a1.66 1.66 0 0 1-1.43.83h-21a1.66 1.66 0 1 1 0-3.31h21a1.66 1.66 0 0 1 1.43 2.49zm.22-12.43a1.1 1.1 0 0 1-1.1 1.1h-6.63a1.1 1.1 0 0 1-1.1-1.1v-7.72a1.1 1.1 0 0 1 1.1-1.1h6.63a1.1 1.1 0 0 1 1.1 1.1zm10.32 15.55v3.87h-3.69V9.31A3.31 3.31 0 0 0 34.24 6H10.31V3.31h30.93z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/inspect-multiple.svg
// module id = 8e2+
// module chunks = 6